import { DeviceWrapper, PageContainer } from '@/components';
import ProfilePageDesktop from './ProfilePageDesktop';
import ProfilePageMobile from './ProfilePageMobile';
import { useTranslation } from 'react-i18next';

export function ProfilePage() {
  const [t] = useTranslation(['common']);
  return (
    <PageContainer noPadding title={t('common:labels.user-profile')}>
      <DeviceWrapper show={['desktop']}>
        <ProfilePageDesktop />
      </DeviceWrapper>
      <DeviceWrapper show={['mobile']}>
        <ProfilePageMobile />
      </DeviceWrapper>
    </PageContainer>
  );
};

export default ProfilePage;
